var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":"60px"}},[_c('img',{attrs:{"src":_vm.source,"alt":"Avatar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }